import React from 'react';
import { doubleSideSmt as tooltip } from 'pu-data/Tooltips';
import RadioDualComponent from './RadioDualComponent';

const DoubleSideSmt = (props) => {
  const name = 'double_sided_smt';
  const onChange = (e) => props.onChangeParameter(name, e.target.value);
  return (
    <RadioDualComponent
      name={name}
      label="Double-sided SMT"
      tooltip={props.tooltip}
      onChange={onChange}
      parameters={props.parameters}
      className={props.className} />
  );
};

DoubleSideSmt.defaultProps = {
  tooltip,
  className: 'double-side-smt',
};

export default DoubleSideSmt;
